import * as React from "react";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import type {} from "@mui/x-charts/themeAugmentation";
import type {} from "@mui/x-data-grid-pro/themeAugmentation";
import type {} from "@mui/x-tree-view/themeAugmentation";
import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppNavbar from "../../components/Dashboard/AppNavbar/AppNavbar";
import Header from "../../components/Dashboard/Header/Header";
import MainGrid from "../../components/Dashboard/MainGrid/MainGrid";
import SideMenu from "../../components/Dashboard/SideMenu/SideMenu";
import ClientsGrid from "../../components/Dashboard/ClientsGrid/ClientsGrid";
import SettingsGrid from "../../components/Dashboard/SettingsGrid/SettingsGrid";
import AppTheme from "../shared-theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "./theme/customizations";

import { useDashboardPage, DashboardPage } from "../../context/DashboardPageContext";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard(props: { disableCustomTheme?: boolean }) {

  const { page } = useDashboardPage()

const pageComponents: Record<DashboardPage, React.ReactNode> = {
  dashboard: <MainGrid />,
  clients: <ClientsGrid />,
  leads: null,
  tasks: null,   // or <TasksGrid />
  settings: <SettingsGrid /> , // or <SettingsPage />
  about: null,    // or <AboutPage />
  feedback: null, // or <FeedbackPage />
};
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme: import("@mui/material/styles").Theme) => ({
            flexGrow: 1,
            backgroundColor: (theme as any).vars
              ? `rgba(${(theme as any).vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header />
            { pageComponents[page] }
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
